/**
 * Hero Widget Scanner — Mamapachita
 * Extracted from hero-mamapachita.liquid (Phase 2 refactor)
 *
 * Manages floating third-party widgets (WhatsApp, gift icons, Klaviyo teasers)
 * by hiding them while the hero is visible and showing them after scroll.
 * Review widgets (Loox, Yotpo) are protected and never hidden.
 *
 * Usage: initHeroWidgets(heroElement, sectionId)
 */

(function () {
  'use strict';

  window.initHeroWidgets = function (hero, sectionId) {
    if (!hero) return;

    /* ── 1. Height management ── */
    var _lastW = window.innerWidth;

    function initHero() {
      var offset = hero.getBoundingClientRect().top + window.scrollY;
      hero.style.setProperty('--header-offset', offset + 'px');

      if (window.innerWidth <= 480) {
        hero.style.setProperty('--hero-h', (window.innerHeight - offset) + 'px');
      } else {
        hero.style.removeProperty('--hero-h');
      }

      hero.style.setProperty('--img-max-h', (window.innerHeight * 0.52) + 'px');
      hero.style.setProperty('--img-max-h-land', (window.innerHeight * 0.38) + 'px');
    }

    initHero();

    window.addEventListener('resize', function () {
      if (Math.abs(window.innerWidth - _lastW) > 5) {
        _lastW = window.innerWidth;
        hero.style.removeProperty('--hero-h');
        hero.style.removeProperty('--img-max-h');
        hero.style.removeProperty('--img-max-h-land');
        requestAnimationFrame(initHero);
      }
    });

    document.addEventListener('shopify:section:load', function () {
      hero.style.removeProperty('--hero-h');
      hero.style.removeProperty('--img-max-h');
      hero.style.removeProperty('--img-max-h-land');
      initHero();
    });

    /* ── 2. Widget hide/show ── */
    var _btns = [];
    var _heroWasVisible = true;
    var _protectedRe = /review|reseñ|jdgm|judge|stamped|loox|yotpo|okendo/i;
    var _skipRe = /header|shopify-section|preview-bar|admin|popover|drawer|sidebar|menu|nav-|navigation|cart|smile|kl-teaser|kl-private/i;

    function _isProtected(el) {
      var sig = ((el.id || '') + ' ' + (typeof el.className === 'string' ? el.className : '')).toLowerCase();
      if (_protectedRe.test(sig)) return true;
      if (_protectedRe.test((el.textContent || '').slice(0, 300).toLowerCase())) return true;
      var node = el.parentElement;
      for (var i = 0; node && i < 4; i++, node = node.parentElement) {
        var s = ((node.id || '') + ' ' + (typeof node.className === 'string' ? node.className : '')).toLowerCase();
        if (_protectedRe.test(s)) return true;
      }
      return false;
    }

    function _checkEl(el) {
      if (el.nodeType !== 1) return;
      if (_btns.indexOf(el) !== -1) return;
      if (el.closest('#hero-' + sectionId)) return;
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed') return;
      var sig = ((el.id || '') + ' ' + (typeof el.className === 'string' ? el.className : '')).toLowerCase();
      if (_skipRe.test(sig)) return;
      var tag = (el.tagName || '').toLowerCase();
      if (_skipRe.test(tag)) return;
      if (el.closest('[id*="shopify-section-header"]') ||
        el.closest('header') ||
        el.closest('.popover') ||
        el.closest('.drawer')) return;
      if (_isProtected(el)) return;
      el.style.transition = 'opacity 0.5s ease';
      _btns.push(el);
    }

    function _scanBtns() {
      for (var k = _btns.length - 1; k >= 0; k--) {
        if (!_btns[k].isConnected) _btns.splice(k, 1);
      }
      var roots = document.body.children;
      for (var i = 0; i < roots.length; i++) {
        var root = roots[i];
        if (root.id && root.id.indexOf('shopify-section') === 0) continue;
        _checkEl(root);
        var kids = root.children;
        if (kids) {
          for (var j = 0; j < kids.length; j++) _checkEl(kids[j]);
        }
      }
    }

    function _toggleBtns() {
      var r = hero.getBoundingClientRect();
      var headerEl = document.querySelector('#shopify-section-header, .shopify-section-group--header-group, header');
      var headerH = headerEl ? headerEl.getBoundingClientRect().bottom : 80;
      var hide = r.bottom > headerH && r.top < window.innerHeight;

      for (var i = 0; i < _btns.length; i++) {
        _btns[i].style.opacity = hide ? '0' : '';
        _btns[i].style.pointerEvents = hide ? 'none' : '';
      }

      var ph = document.getElementById('hero-prehide-' + sectionId);
      if (ph) ph.disabled = !hide;

      if (!hide && _heroWasVisible) {
        _heroWasVisible = false;
        setTimeout(function () {
          window.dispatchEvent(new Event('resize'));
        }, 150);
      }
    }

    /* Initial + timed scans */
    _scanBtns(); _toggleBtns();
    setTimeout(function () { _scanBtns(); _toggleBtns(); }, 200);
    setTimeout(function () { _scanBtns(); _toggleBtns(); }, 500);
    setTimeout(function () { _scanBtns(); _toggleBtns(); }, 1500);
    setTimeout(function () { _scanBtns(); _toggleBtns(); }, 4000);
    setTimeout(function () { _scanBtns(); _toggleBtns(); }, 8000);

    /* MutationObserver */
    var _debounceTimer = null;
    new MutationObserver(function (m) {
      var added = false;
      for (var i = 0; i < m.length; i++) {
        var nodes = m[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          if (nodes[j].nodeType === 1) {
            _checkEl(nodes[j]);
            var kids = nodes[j].children;
            if (kids) {
              for (var k = 0; k < kids.length; k++) _checkEl(kids[k]);
            }
            added = true;
          }
        }
      }
      if (added) _toggleBtns();
      clearTimeout(_debounceTimer);
      _debounceTimer = setTimeout(function () { _scanBtns(); _toggleBtns(); }, 100);
    }).observe(document.body, { childList: true, subtree: true });

    window.addEventListener('scroll', _toggleBtns, { passive: true });

    /* ── 3. CTA smooth scroll ── */
    var ctaLink = hero.querySelector('.hero__cta a');
    if (ctaLink) {
      ctaLink.addEventListener('click', function (e) {
        var href = ctaLink.getAttribute('href') || '';
        var samePage = !href || href === '#' || href === '/'
          || href === window.location.pathname
          || href === window.location.href;
        if (!samePage && href.charAt(0) === '#') samePage = true;

        if (samePage) {
          var wrapper = hero.closest('[id^="shopify-section"]') || hero.parentElement;
          var next = wrapper ? wrapper.nextElementSibling : null;
          if (next) {
            e.preventDefault();
            next.scrollIntoView({ behavior: 'smooth' });
          }
        }
      });
    }
  };
})();
